import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'hr-confirm-with-checkbox',
  templateUrl: './confirm-with-checkbox.component.html',
  styleUrls: ['./confirm-with-checkbox.component.less'],
  standalone: false,
})
export class ConfirmWithCheckboxComponent implements OnInit {
  public display: boolean;
  public checkboxValue: boolean;

  @Input() public targetId: any;
  @Input() public header: string;
  @Input() public content: string;
  @Input() public checkboxLabel: string;
  @Input() public actionName: string;

  constructor() {
    this.reset();
  }

  public onConfirm() {
    this.onResult.emit({
      agree: true,
      id: this.targetId,
      checked: this.checkboxValue,
    });
    this.reset();
  }

  public onCancel() {
    this.onResult.emit({ agree: false });
    this.reset();
  }

  public onActionClick() {
    this.display = true;
  }

  public reset() {
    this.display = false;
    this.checkboxValue = false;
  }

  @Output()
  public onResult: EventEmitter<any> = new EventEmitter<any>();

  ngOnInit() {}
}
